import getRedirectUrl from './getRedirectUrl'
import redirect from './redirect'

export default async function makePayment(order, router) {
  const {url, post} = getRedirectUrl({
    paymentType: order.paymentType,
    transaction: order.transaction,
    intent: order.intent
  })
  if (post === true) {
    redirect(url)
  } else if (url) {
    window.location.href = url
  } else {
    router.replace(`/track/${order._id}`)
  }
}
